import React, { useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { FaYoutube, FaTiktok, FaInstagram } from 'react-icons/fa';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Title, Tooltip, Legend, Filler);

const ViewsChart = () => {
  useEffect(() => {
    const logos = document.querySelectorAll('.chart-logo');
    logos.forEach((logo, index) => {
      setTimeout(() => {
        logo.style.opacity = '1';
        logo.style.transform = 'translateY(0)';
      }, 500 + (index * 200)); // Smooth staggered animation
    });
  }, []);

  const data = {
    labels: ['Day 1', 'Day 10', 'Day 15', 'Day 20', 'Day 25', 'Day 28', 'Day 30'],
    datasets: [
      {
        label: '',
        data: [100000000, 200000000, 300000000, 350000000, 420000000, 430000000, 455000000],
        borderColor: '#4CAF50', // Fresh green for a clean look
        fill: true,
        backgroundColor: 'rgba(76, 175, 80, 0.2)', // Soft green background
        tension: 0.3, // More gentle curve
        pointRadius: 6,
        pointHoverRadius: 10,
        borderWidth: 3,
        cubicInterpolationMode: 'monotone',
        hoverBackgroundColor: '#4CAF50',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 1500,
      easing: 'easeOutQuad',
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Darker tooltip for better contrast
        titleColor: '#fff',
        bodyColor: '#fff',
        callbacks: {
          label: function (context) {
            return `Views: ${context.raw.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      x: {
        display: false, // Remove x-axis for a cleaner look
        grid: {
          display: false,
        },
      },
      y: {
        display: false, // Hide y-axis as well
        grid: {
          display: false,
        },
      },
    },
    elements: {
      point: {
        backgroundColor: '#4CAF50',
        borderColor: '#fff',
        borderWidth: 2,
      },
    },
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', background: 'linear-gradient(to bottom, #f7f7f7, #ffffff)' }}>
      <Line data={data} options={options} />
      
      {/* Animated Social Logos */}
      <FaYoutube 
        className="chart-logo youtube" 
        style={{
          position: 'absolute',
          left: '12%',
          top: '25%',
          fontSize: 'clamp(3rem, 6vw, 6rem)',
          color: '#FF0000',
          opacity: 0,
          transform: 'translateY(20px)',
          transition: 'all 0.8s ease-out',
          animation: 'float 3s ease-in-out infinite 1.5s',
        }} 
      />
      
      <FaTiktok 
        className="chart-logo tiktok" 
        style={{
          position: 'absolute',
          left: '40%',
          top: '55%',
          fontSize: 'clamp(3rem, 6vw, 6rem)',
          color: '#000',
          opacity: 0,
          transform: 'translateY(20px)',
          transition: 'all 0.8s ease-out',
          animation: 'float 3s ease-in-out infinite 2s',
        }} 
      />
      
      <FaInstagram 
        className="chart-logo instagram" 
        style={{
          position: 'absolute',
          left: '72%',
          top: '35%',
          fontSize: 'clamp(3rem, 6vw, 6rem)',
          color: '#E1306C',
          opacity: 0,
          transform: 'translateY(20px)',
          transition: 'all 0.8s ease-out',
          animation: 'float 3s ease-in-out infinite 2.5s',
        }} 
      />
    </div>
  );
};

export default ViewsChart;
